/**
 * 画像への右クリック禁止、ドラッグ禁止
 */


const preventImgs = () => {
  const $img = document.querySelectorAll('img')
  const $video = document.querySelectorAll('video')
  $img.forEach(element => {
    element.oncontextmenu = function () { return false; }
    element.onselectstart = function () { return false; }
    element.onmousedown = function () { return false; }
  })
  $video.forEach(element => {
    element.oncontextmenu = function () { return false; }
    element.onselectstart = function () { return false; }
    element.onmousedown = function () { return false; }
  })
}


export { preventImgs };
